import { render, staticRenderFns } from "./rightsComment.vue?vue&type=template&id=5f823d7f&scoped=true"
import script from "./rightsComment.vue?vue&type=script&lang=js"
export * from "./rightsComment.vue?vue&type=script&lang=js"
import style0 from "./rightsComment.vue?vue&type=style&index=0&id=5f823d7f&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f823d7f",
  null
  
)

export default component.exports